
export const AgreementNotificationValidation = (formData) => {
    const errors = {};
    debugger;
    if (!formData.vc_Email || !formData.vc_Email.trim()) {
        errors.vc_Email = 'This field is required';
    }
    if (!formData.vc_Other || !formData.vc_Other.trim()) {
        errors.vc_Other = 'This field is required';
    }
     return errors;
};
